import React from "react";
import {
  LineChart,
  Line,
  Tooltip,
  Legend,
  ResponsiveContainer,Dot
} from "recharts";

const data = [
  {
    
    pv: 6,
   
  },
  {
   
    pv: 23,
    
  },
  {
    
    pv: 14,
    
  },
  {
    
    pv: 22,
    
  },
  {
    pv: 40,
  },
  {
    pv: 27,
  },
  {
    pv: 18,
  }
];

export default function ChartTwo() {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const dataItem = payload[0].payload;
      return (
        <div style={{ backgroundColor: 'black', padding: '5px', color: 'white' }}>
          <p>{`Value: ${dataItem.pv}`}</p>
        </div>
      );
    }

    return null;
  };
  const CustomDot = (props) => {
    const { cx, cy } = props;

    return (
      <Dot
        {...props}
        cx={cx}
        cy={cy}
        fill="none" // Customize the color of the dots
        stroke="white" // Customize the border color of the dots
        r={4} // Set the radius of the dots
      />
    );
  };

  return (
    <ResponsiveContainer width="99%" height="45%">
      <LineChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom:5
        }}
      >
        {/* <CartesianGrid strokeDasharray="3 3" /> */}
        {/* <XAxis dataKey="name" /> */}
        {/* <YAxis /> */}
        <Tooltip content={<CustomTooltip/>}/>
        {/* <Legend /> */}
        <Line
          type="monotone"
          dataKey="pv"
          stroke="white"
          activeDot={{ r: 4 }}
          dot={<CustomDot />}
        />
        {/* <Line type="monotone" dataKey="uv" stroke="#82ca9d" /> */}
      </LineChart>
    </ResponsiveContainer>
  );
}
